import { Tag } from "primereact/tag";
import { classNames } from "primereact/utils";

import styles from "./tag-coletor.module.scss";
import type { TagColetorProps } from "./types-tag-coletor";

/** Classe da cor própria de cada código do coletor (Figma `tag-coletor`); código sem cor usa o tom secondary (cinza). */
const CLASSE_POR_CODIGO: Record<string, string | undefined> = {
  "100": styles.c100,
  "101": styles.c101,
  "102": styles.c101,
  "103": styles.c103,
  "105": styles.c105,
  "301": styles.c105,
};

export function TagColetorView({ codigo }: TagColetorProps) {
  const classe = CLASSE_POR_CODIGO[codigo];
  return (
    <Tag
      value={codigo}
      severity={classe ? undefined : "secondary"}
      className={classNames(styles.tag, classe)}
    />
  );
}
